import { RiskDetails } from '@/models';

export default function getRiskByGroup(riskGroups: Record<string, any>) {
  const figures: Record<string, string> = {};
  Object.keys(riskGroups).forEach((group) => {
    let groupPercent = 0;

    riskGroups[group].forEach((signal: RiskDetails) => {
      groupPercent += Number(signal.value);
    });

    figures[group] = groupPercent.toFixed(1);
  });

  return figures;
}
